var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 1063 708.66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    strokeWidth: "1pt",
    d: "M0 0H1063V708.66H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#00bf13",
    fillRule: "evenodd",
    strokeWidth: "1pt",
    d: "M0 0H531.5V708.66H0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#f21930",
    fillRule: "evenodd",
    strokeWidth: "1pt",
    d: "M692.45 439.71c-50.15 90.2-160.76 122.25-248.65 73.84s-119.93-159.03-71.52-246.92c48.41-87.88 159.02-119.92 246.91-71.51 32.49 17.89 55.63 41.42 73.82 74.93-6.64-9.13-14.05-16.67-23.78-24.32-59.95-47.13-146.85-36.73-193.99 23.22-47.12 59.95-36.72 146.85 23.22 193.98 59.95 47.13 146.86 36.73 193.99-23.22z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#f21930",
    fillRule: "evenodd",
    strokeWidth: "1pt",
    d: "M647.32 458.71L603.55 396.67 531.37 420.21 576.84 359.41 532.15 298.04 604.03 322.5 648.59 261.03 647.53 336.95 719.76 360.33 647.24 382.78z",
    transform: "translate(2.181 -2.905)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDz);
export default __webpack_public_path__ + "static/media/dz.4d555ace.svg";
export { ForwardRef as ReactComponent };